import React from "react";
import firebase from '../../config/fbConfig';
import 'firebase/storage';  

async function GetLogo(logoName) {
    var storage = firebase.storage();
    var gsReference = storage.refFromURL('gs://zoom-back.appspot.com')
    gsReference.child(logoName).getDownloadURL().then(function(url) {
      var img = document.getElementById('myimg');
      img.src = url;
    }).catch(function(error) {
        switch (error.code) {
          case 'storage/object-not-found':
            console.log("File doesn't exist")
            break;
          case 'storage/unauthorized':
            console.log("User doesn't have permission to access the object")
            break;
          case 'storage/canceled':
            console.log("User canceled the upload")
            break;
          case 'storage/unknown':
            console.log("Unknown error occurred, inspect the server response")
            break;
          default:
            console.log("No idea")
        }
    });
}

const Logo = (props) => {
    const styleObj = {
        width: `${props.logoWidth}%`
    }
    if(props.dropdown === 'local') {
        GetLogo(props.logo);
    }
    return props.dropdown === 'typed' ? (
        <div className='input-details'>
            <input 
                value={props.logo}
                style={props.logoStyleObj} />
        </div>
    ) : props.dropdown === 'local' ? 
        <img id='myimg' className='logo-local' src='' style={styleObj} alt={props.logo}/>
    : <img className='logo-web' src={props.logo} style={styleObj} alt={props.logo}/>
};

export default Logo;
